(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["lo-section-popup-modal-v2"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function() {

  
    var show_popup =  $('#pop-value').val();
    console.log(show_popup);
       if(show_popup=='true'){
         console.log('on');
          window.onload = function () {
            setTimeout(function() {
              if (localStorage.getItem("hasCodeRunBefore") === null) {
                $('#PopUpModalV2').css('display','block');
                localStorage.setItem("hasCodeRunBefore", true);
              }
            }, 10000);
        }
       }else  if(show_popup=='false'){
         console.log('off');
       }





    $("#btnPopUpclose").click(function() {
        $('#PopUpModalV2').css('display','none');
   
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lo-section-sub-categories"] && !window.DesignMode) return;
  try {
    
$( document ).ready(function() {
  	$('.Slider-subcategories-reebok-mo').slick({
 		dots: false,
  		infinite: true,
  		speed: 300,
  		slidesToShow: 2,
  		slidesToScroll: 2,
        arrows:true,
        prevArrow:"<button type='button' class='slick-prev pull-left'> &#9666; </button>",
        nextArrow:"<button type='button' class='slick-next pull-right'> &#9656; </button>"
	});
}); 
 

  } catch(e) { console.error(e); }
})();

})();
